module.exports = __webpack_public_path__ + "static/media/Right legs14.794865a5.png";